import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { imageUrl } from "../lib/api";

export const ProductCard = ({ product, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
      data-testid={`product-card-${product.id}`}
      className="group border border-border bg-card"
    >
      <Link to={`/product/${product.id}`}>
        <div className="relative overflow-hidden aspect-[3/4] bg-muted">
          <img src={imageUrl(product.images?.[0])} alt={product.name} loading="lazy" decoding="async"
            className={`w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105 ${!product.in_stock ? "grayscale opacity-70" : ""}`} />
          {!product.in_stock && (
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="overline bg-[hsl(var(--secondary))] text-white px-4 py-2" data-testid="sold-out-badge">Sold Out</span>
            </div>
          )}
          {product.original_price && product.in_stock && (
            <span className="absolute top-4 left-4 overline bg-[hsl(var(--primary))] text-white px-3 py-1">Sale</span>
          )}
          <span className="absolute top-4 right-4 overline text-foreground/60 bg-background/80 px-2 py-1 capitalize">{product.category}</span>
        </div>
        <div className="p-5 flex items-start justify-between gap-4 border-t border-border">
          <div>
            <h3 className="font-display text-xl leading-tight">{product.name}</h3>
            <p className="overline text-muted-foreground mt-2">{product.fabric}</p>
          </div>
          <div className="text-right shrink-0">
            <p className="font-body font-600 text-base">₹{product.price}</p>
            {product.original_price && <p className="font-body text-xs text-muted-foreground line-through">₹{product.original_price}</p>}
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
